/**
 * 시스템 > 외부 연동 서버 > 시그니처 수집 이력
 *
 * @since 2019-04-12
 * @author devp011
 */

export const state = () => ({
  detailsUrl: '/api/sm/external/signtr/server/hstry', // orange
  serverNameList: [],
  search: {
    id: '',
    page_num: 1,
    isFirst: true
  },
  searchData: {
    log_type: '',
    stime: '',
    etime: '',
    total_rows: 10000,
    page_rows: 1000,
    order_by: 'desc',
    filters: []
  },
  searchState: {
    status: 'INIT', // 초기 단계: INIT, 추이 검색 중: SEARCHING_TREND_LOG, 로그 검색 중: SEARCHING_LOG, 검색 중지 요청 중: REQUEST_STOP, 로그 검색이 중지 됨: STOPPED, 로그 검색 완료: DONE
    progress: 0,
    searched_cnt: 0
  },
  // 필터 key 변경
  filterKey: {
    signtr_server_hstry_result_type: 'signtr_server_hstry_result_type',
    signtr_server_hstry_type: 'signtr_server_hstry_type',
    signtr_server_uname: 'signtr_server_uname'
  },
  trendData: [],
  chgFieldData: null,
  // data
  dataList: [],
  errorMessage: ''
})

export const mutations = {
  mutGetSearchResult (state, payload) {
    state.serverNameList = []
    state.dataList = payload.filter(item => {
      // // 메뉴 이름
      // item.menu_name = getChildrenFindVal(state.menuData, {id: 'code', val: item.menu_id.toString()}, 'name')
      // // 동기화 이력 유형
      // const syncHstryType = state.syncHstryType.filter(_item => {
      //   return _item.value === item.sync_hstry_type
      // })
      // item.sync_hstry_type_name = ''
      // if (syncHstryType.length > 0) {
      //   item.sync_hstry_type_name = syncHstryType[0].label
      // }
      // 결과
      // item.signtr_server_hstry_result_type = resultTypeText[item.signtr_server_hstry_result_type] // orange
      // 동기화 유형
      // _.map(state.syncType, sync => {
      //   if (sync.value === item.sync_type) {
      //     item.sync_type_name = sync.label
      //   }
      // })
      return item
    })
  },
  mutGetSearchState (state, payload) {
    state.searchState.searched_cnt = payload
    state.search.page_num = 1
  },
  mutErrorMessage (state, payload) {
    const msg = {
      error: payload
    }
    state.errorMessage = msg
  }
}

export const actions = {
  async getSearchResult ({commit, state}) {
    let filter = ''
    state.searchData.filters.forEach(item => {
      const key = state.filterKey[item.key]
      const codesD = (item.code[item.key] !== undefined) ? item.code[item.key] : item.code
      if (typeof key !== 'undefined') {
        if (key === 'signtr_server_uname') {
          filter = filter + '&signtr_server_id_list=' + '[' + codesD + ']'
        }
        if (key === 'signtr_server_hstry_type' || key === 'signtr_server_hstry_result_type') {
          filter = filter + '&' + key + '=' + parseInt(codesD[0])
        }
      }
    })
    const axiosData = (filter.substr(1) + '&search_start_dt=' + state.searchData.stime + '&search_end_dt=' +
      state.searchData.etime + '&page_cnt=' + state.searchData.page_rows + '&page_pos=' + (state.search.page_num - 1))
    await this.$axios.$get(`${state.detailsUrl}?${axiosData}`)
    const data = {
      'code': 'ok',
      'result': [
        {
          'signtr_server_hstry_del_cnt': 10,
          'signtr_server_hstry_dt': '2018-08-16 16:36:08',
          'signtr_server_hstry_id': 1,
          'signtr_server_hstry_mod_cnt': 10,
          'signtr_server_hstry_new_cnt': 10,
          'signtr_server_hstry_result_type': 1,
          'signtr_server_hstry_type': 1,
          'signtr_server_id': 1,
          'signtr_server_uname': 'ECSC'
        },
        {
          'signtr_server_hstry_del_cnt': '',
          'signtr_server_hstry_dt': '2018-08-16 16:36:08',
          'signtr_server_hstry_id': 1,
          'signtr_server_hstry_mod_cnt': '',
          'signtr_server_hstry_new_cnt': 10,
          'signtr_server_hstry_result_type': 1,
          'signtr_server_hstry_type': 1,
          'signtr_server_id': 5,
          'signtr_server_uname': 'TOTO'
        }
      ]
    }
    if (data.code === 'ok') {
      commit('mutGetSearchResult', data.result)
      commit('mutGetSearchState', data.result.length)
      return true
    }
    commit('mutErrorMessage', data.result.msg)
    return false
  }
}
export const getters = {}
export const strict = false
